<template>
    <div>
        <div class="media">
            <div class="media-body text-semi-bold text-left">
                {{ file.name }}
            </div>
            <div v-if="info.status === documentUploadStatuses.uploading.key" class="pr-2">
                {{ info.percentage }}%
            </div>
            <div v-if="info.status === documentUploadStatuses.duplicate.key"
                 v-tooltip="'Open existing document'"
                 @click="openDocument(info.document)"
                 class="text-purple clickable mr-2">
                <i class="fal fa-arrow-up-right-from-square"></i>
            </div>
            <div v-if="info.status !== documentUploadStatuses.uploading.key"
                 v-tooltip="info.details || uploadStatusModel.text"
                 :key="uploadStatusModel.icon"
                 :class="uploadStatusModel.class">
                <i :class="uploadStatusModel.icon"></i>
            </div>
        </div>
        <div :class="uploadStatusModel.bgClass"
             class="progress-bar rounded"
             role="progressbar"
             aria-valuemin="0"
             aria-valuemax="100"
             :aria-valuenow="info.percentage"
             :style="`width: ${info.percentage}%; height: 12px`">
        </div>
    </div>
</template>

<script>
import {documentUploadStatuses, getDocUploadStatusModelByKey} from './documentUploadStatuses'
import {getDocSystemTypeDefaultModel} from '@/types/document/types'
import {showErrorMessage} from '@/services/snackbar'
import {mapGetters} from 'vuex'

export default {
    name: 'DocUploadProgress',
    props: {
        file: {},
        info: {}
    },
    data() {
        return {
            documentUploadStatuses
        }
    },
    computed: {
        ...mapGetters([
            'activeTeamId'
        ]),

        uploadStatusModel() {
            return getDocUploadStatusModelByKey(this.info.status)
        }
    },
    methods: {
        openDocument(doc) {
            if (!doc || !doc.uuid || !doc.section) {
                showErrorMessage()
                return
            }
            const sectionModel = getDocSystemTypeDefaultModel(doc.section)
            const routeData = this.$router.resolve({
                name: `${sectionModel.route}.view`,
                params: {
                    team: this.activeTeamId,
                    docUuid: doc.uuid
                }
            })
            window.open(routeData.href, '_blank')
        }
    }
}
</script>
